import * as React from "react";
import {PropsWithChildren} from "react";
import {classNames, useFlag} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {AwesomeBarDropdown, AwesomeBarDropdownProps} from "../AwesomeBarDropdown";
import {AwesomeBarItem} from "../AwesomeBarItem";

interface ToolProps {
    label: string;
    highlight?: boolean;
    align?: AwesomeBarDropdownProps["alignContent"];
}

export function Tool({children, label, highlight, align = "left"}: PropsWithChildren<ToolProps>) {
    const [open, setOpen, clearOpen] = useFlag(false);

    return (
        <AwesomeBarDropdown
            open={open}
            onClose={clearOpen}
            button={<ToolButton onClick={setOpen} label={label} highlight={highlight}/>}
            alignContent={align}
            position="above"
        >
            <div className={styles.content}>
                {children}
            </div>
        </AwesomeBarDropdown>
    )
}


interface ToolButtonProps {
    label: string;
    highlight?: boolean;
    onClick: () => void;
}

function ToolButton({label, onClick, highlight}: ToolButtonProps) {
    return (
        <AwesomeBarItem onClick={onClick} className={styles.toolButton}>
            {label}
            <div className={classNames(styles.highlight, highlight && styles.highlightOn)}/>
        </AwesomeBarItem>
    )
}

const styles = stylesheet({
    toolButton: {
        fontSize: "1.25rem",
        background: "transparent",
        padding: "0 0.5em",
        border: 0,
        cursor: "pointer",
    },
    content: {
        background: "#222",
    },
    highlight: {
        width: "0.5em",
        height: "0.5em",
        marginLeft: "0.25em",
        backgroundColor: "var(--color-primary)",
        borderRadius: "50%",
        opacity: 0,
    },
    highlightOn: {
        opacity: 1,
    }
})